import React from "react";

function Home() {
  return (
    <div className="pt-[10%]">
      <div className="flex flex-col items-center  h-[100%] font-nautigal ">
        <p className="text-4xl md:text-5xl lg:text-6xl 2xl:text-7xl ">
          Avvocato
        </p>
        <p className="text-6xl md:text-7xl lg:text-8xl 2xl:text-9xl ">
          Valentina Mango
        </p>
      </div>
      <div className="pl-[5%] pr-[5%] pt-[10%] pb-[5%] ">
        <p>
          L&apos;Avvocato Valentina Mango garantisce assistenza e consulenza
          specifica in tutto ciò che concerne le successioni. Lavorando a Roma e
          a Palermo, ha affinato la sua esperienza nel corso dei numerosi anni
          di esercizio, mostrando la massima efficienza e attenzione nella
          comprensione delle esigenze personali di chi richieda la risoluzione
          di qualsiasi problematica che concerne il presentazioni di
          dichiarazione di successione, consulenze in materia successoria, esami
          di eventuale lesione di legittima, diseredazione e intangibilità di
          legittima.
        </p>
        <br/>
        <p>
          Forte di un&apos;istruzione di alto livello e sempre al passo con le
          evoluzioni nel campo delle successioni, l&apos;Avvocato Mango è in
          grado di fornirvi risposte affidabili e su misura.
        </p>
      </div>
    </div>
  );
}

export default Home;
